export const Permission =
{
    CUSTOMER: "CUS100",
    PERMISSION: "PMS100",
    PRODUCT: "PRT100",
    QUOTATION: "QUO100",
    QUOTATION_APPROVAL: "QOA100",
    TRANSPORTATION: "TRA100",
    USER: "USR100",
    USER_APPROVE: "USA100",

};

export const Action_Permission = {
    VIEW: '100',
    CREATE: '150',
    EDIT: '200',
    APPROVE: '500',
    DELETE: '600',
    PRINT: "300",
    IMPORT: "800",
    EXPORT: "900",
}




// WEBPACK FOOTER //
// ./src/app/permission/permission.ts